module.exports = __webpack_public_path__ + "img/logo.01d26628.png";